import { Container } from '@mui/system';
import { NavLink } from 'react-router-dom';
import menu from '../../config/menu';

const Footer = ({ source = null }) => {

  const renderContent = () =>{
    return <div className={`site-footer${source ? ` sf-s sf-${source}` : ''}`}>
      <div className="cr">
        © Copyright {new Date().getFullYear()}
      </div>
      <div className="links">
        {menu?.footer && menu.footer.map((mitem,mi)=><NavLink key={`menu_footer_${mi}`} to={mitem?.path}>{mitem.title}</NavLink>)}
      </div>
    </div>;
  }

  return source ? renderContent() : <Container>{renderContent()}</Container>;

};

export default Footer;
